import React from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { List, ListItemButton, ListItemText } from '@mui/material';

import type { OpportunityRelatedInclusion } from '~/hooks/apis/offers/useGetOpportunityRelated';

interface Props {
  inclusions: Array<OpportunityRelatedInclusion>;
  selectedId?: string;
  onSelect: (id: string) => void;
}

export default function InclusionAssetList({ inclusions, selectedId, onSelect }: Props) {
  return (
    <List component="nav" aria-label="Inclusion assets" dense disablePadding>
      {inclusions.map((inclusion) => (
        <ListItemButton
          key={inclusion.id}
          selected={inclusion.id === selectedId}
          onClick={() => onSelect(inclusion.id)}
        >
          <ListItemText primary={inclusion.name || inclusion.id} />
          <ChevronRightIcon fontSize="small" color="action" />
        </ListItemButton>
      ))}
    </List>
  );
}
